import { render } from "./DeleteLanguageModal.vue?vue&type=template&id=c3acaf18"
import script from "./DeleteLanguageModal.vue?vue&type=script&lang=js"
export * from "./DeleteLanguageModal.vue?vue&type=script&lang=js"
script.render = render

export default script